import { render, staticRenderFns } from "./LandAcquisition.vue?vue&type=template&id=0720f48f&scoped=true"
import script from "./LandAcquisition.vue?vue&type=script&lang=ts"
export * from "./LandAcquisition.vue?vue&type=script&lang=ts"
import style0 from "./LandAcquisition.vue?vue&type=style&index=0&id=0720f48f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0720f48f",
  null
  
)

export default component.exports